import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
    cancelOrderApi,
    labDashboardAPI,
    labOrderListAPI,
    pharmacyDashboardAPI,
    pharmacyDashboardOrdersAPI,
    updateOrderStatusAPI,
    updateSampleStatusAPI,
} from "../../api/pahrmacy";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    Row,
} from "../../components/Component";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import OrderRecent from "../../components/partials/default/recent-orders/OrderRecent";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import useLogout from "../../hooks/useLogout";
import CancelOrderModal from "../../MyComp/UI/modals/CancelOrderModal";
import { decrypt } from "../../utils/Utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LabOrderData from "../../MyComp/UI/MyPrint/LabOrderData";
import PharmacyOrder from "../../components/partials/default/recent-orders/PharmacyOder";
import { tellecallerDashBoard } from "../../api/TellecallerUser";
import { telecallerOrderList } from "../../api/pahrmacy";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const TelecallerDashboardOrders = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useLogout();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: true,
            tableLoading: true,
            orderData: [],
            cardData: [],
            salesData: [],
            orders: [],
            customerData: [],
            storeStats: [],
            limit: 10,

            mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [onSearch, setonSearch] = useState(false);
    const [onSearchText, setSearchText] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    const isLoading = watch("isLoading");
    const tableLoading = watch("tableLoading");
    const orderData = watch("orderData");
    const salesData = watch("salesData");
    const storeStats = watch("storeStats");
    const orders = watch("orders");
    const limit = watch("limit");
    const customerData = watch("customerData");
    const user = decrypt(localStorage.getItem("userDetail"));
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow1, setSelectedRow1] = useState([]);
    const toggleModal = () => setIsOpen(!isOpen);

    const userId = localStorage.getItem("userId");

    let userName = location?.state?.name;
    let labId = location?.state?.labId;

    useEffect(() => {
        if (user?.role == "lab") {
            setValue("user", user?.name);
            setValue("id", user?.id);
            console.log("yser--------->", user);
        }
    }, []);
    console.log("lab name", watch("id"), watch("user"));

    const cardData = watch("cardData");


    useEffect(() => {
        const labIDValue = labId || user?.id;

        if (!labIDValue) return;

        const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            labId: labIDValue,
        };

        getOrders(body);
    }, [debouncedSearch, currentPage, itemPerPage, labId, location?.state?.status]);

    const getOrders = async (body) => {
        setValue("tableLoading", true);

        try {
            const res = await telecallerOrderList({
                search: body?.search,
                page: body?.page,
                limit: body?.limit,
                labId: body?.labId,
                status: location?.state?.status, // ✅ IMPORTANT (filter from dashboard)
            });

            if (res?.data?.status === true) {
                const data = res?.data?.data;

                setValue("orderData", data); // full response
                setValue("limit", data?.totalPages || 1);
                setValue("tableLoading", false);
                setValue("isLoading", false);
            }
            else if (res?.data?.status === "expired") {
                logout();
            }
            else {
                setValue("tableLoading", false);
            }
        } catch (err) {
            console.error(err);
            setValue("tableLoading", false);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(onSearchText);
        }, 500); // 500ms debounce delay

        return () => {
            clearTimeout(handler);
        };
    }, [onSearchText]);

    const onOrderClick = (item) => {
        const body = {
            orderId: item?.id,
            userId: item?.userId,
        };
        navigate("/order-details", { state: body });
    };

    const onViewClick = (item) => {
        const body = {
            orderId: item?.id,
            userId: item?.userId,
        };
        navigate("/Lab-Order", { state: body });
    };
    const [showModal, setShowModal] = useState(false);

    const [selectedRow, setSelectedRow] = useState(false);
    const toggleCancelOrder = (item) => {
        setShowModal(true);
        setSelectedRow(item);

        console.log(item, "item");
    };

    const handleCancelOrder = (reason) => {
        if (!selectedRow) return;
        console.log(selectedRow, "selectedRow");

        const payload = {
            orderId: selectedRow?.id,
            remark: reason,
            mobile: selectedRow?.mobile,
        };

        console.log("Confirmed cancel order:", payload);

        cancelOrderApi(payload)
            .then((res) => {
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    toast.clearWaitingQueue();
                    setShowModal(false);
                    const body = {
                        search: debouncedSearch,
                        page: currentPage,
                        limit: itemPerPage,
                        // pharmacyId: location?.state?.pharmacyId,
                        labId: location.state.labId,
                    };

                    getOrders(body);
                } else if (res.data.status === false) {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
            });
    };


    const RecentOrdersSkeleton = ({ rows = 6 }) => {
        return (
            <div className="card card-bordered">
                {/* Header */}
                <div className="card-inner d-flex justify-content-between align-items-center">
                    <Skeleton width={150} height={22} />
                    <div className="d-flex gap-3">
                        <Skeleton width={24} height={24} circle />
                        <Skeleton width={24} height={24} circle />
                    </div>
                </div>

                {/* Table */}
                <div className="nk-tb-list is-separate">
                    {/* Table Head */}
                    <div className="nk-tb-item nk-tb-head">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div className="nk-tb-col" key={i}>
                                <Skeleton width={80} height={14} />
                            </div>
                        ))}
                    </div>

                    {/* Rows */}
                    {Array.from({ length: rows }).map((_, idx) => (
                        <div className="nk-tb-item" key={idx}>
                            {/* Order No */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Customer */}
                            <div className="nk-tb-col">
                                <div className="d-flex align-items-center gap-2">
                                    <Skeleton width={36} height={36} circle />
                                    <Skeleton width={120} height={14} />
                                </div>
                            </div>

                            {/* Date */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Amount */}
                            <div className="nk-tb-col">
                                <Skeleton width={60} height={14} />
                            </div>

                            {/* Address */}
                            <div className="nk-tb-col">
                                <Skeleton width={180} height={14} />
                            </div>

                            {/* Purchased */}
                            <div className="nk-tb-col">
                                <Skeleton width={180} height={14} />
                            </div>

                            {/* Pharmacy */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Status */}
                            <div className="nk-tb-col">
                                <Skeleton width={70} height={14} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };
    const updateOrderStatus = (item) => {
        console.log("order", item);
        const payload = {
            orderId: item?.id,
            status: item?.next_status,
        };

        updateOrderStatusAPI(payload)
            .then((res) => {
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    toast.clearWaitingQueue();
                    setIsOpen(false);
                    const body = {
                        search: debouncedSearch,
                        page: currentPage,
                        limit: itemPerPage,
                        labId: location?.state?.labId,
                    };

                    getOrders(body);
                } else if (res.data.status === false) {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                // toast.error(err?.response?.data?.message);
            });
    };


    return (
        <>
            <Head title={"Telecaller Dashboard"} />
            <Content>
                <BlockHead size={`sm`}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3" className={"text-capitalize"}>
                                {watch("user")} {"Telecaller Dashboard Orders"}
                            </BlockTitle>
                        </BlockHeadContent>
                        {user?.role == "admin" && (
                            <BlockHeadContent>
                                <div className="">
                                    <Button
                                        color="primary"
                                        outline
                                        className={`  me-n1`}
                                        onClick={() => {
                                            navigate("/lab");
                                        }}
                                    >
                                        <Icon name={"arrow-left"} />
                                    </Button>
                                </div>
                            </BlockHeadContent>
                        )}
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <div className=" my-3">

                    </div>
                    <Row className="g-gs">

                        <Col xxl="4">
                            <Row className="g-gs">

                            </Row>
                        </Col>{" "}
                        <Col xxl="12">
                            {tableLoading ? (
                                <RecentOrdersSkeleton rows={6} />
                            ) : (
                                <PharmacyOrder
                                    setSearchText={setSearchText}
                                    onSearchText={onSearchText}
                                    onSearch={onSearch}
                                    setonSearch={setonSearch}
                                    data={orderData}
                                    limit={limit}
                                    setItemPerPage={setItemPerPage}
                                    itemPerPage={itemPerPage}
                                    paginate={paginate}
                                    currentPage={currentPage}
                                    isLoading={tableLoading}
                                    onOrderClick={onOrderClick}
                                    onViewClick={onViewClick}
                                    toggleCancelOrder={toggleCancelOrder}
                                    updateOrderStatus={updateOrderStatus}
                                    isOpen={isOpen}
                                    setIsOpen={setIsOpen}
                                    setSelectedRow={setSelectedRow1}
                                    selectedRow={selectedRow1}
                                    hideDeliveryBoyInfo={true}
                                    isTelecaller={true}
                                />
                            )}
                        </Col>
                    </Row>
                </Block>
            </Content>
            <CancelOrderModal
                isOpen={showModal}
                toggle={() => setShowModal(!showModal)}
                onConfirm={handleCancelOrder}
                item={selectedRow}
            />


        </>
    );
};

export default TelecallerDashboardOrders;
